/* eslint no-template-curly-in-string: 0 */
import { FLOW_TYPES, PAYMENT_NETWORKS } from "../../../../utils/enums";

export const officeDepot = {
  id: PAYMENT_NETWORKS.OFFICE_DEPOT,
  displayName: "Office Depot",
  paymentFlow: "email",
  paywall: {
    tile: {
      displayName: "Office Depot eGiftCard™",
      tagline: "Use en línea o en la tienda",
      description: [
        {
          string: "Fondos inmediatos para comprar sus artículos",
          type: "div",
        },
        {
          string: "favoritos, regalos y más",
          type: "div",
        },
      ],
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparando su Office Depot eGiftCard™"
    }
  },
  acceptPayment: {
    flow: FLOW_TYPES.ACCEPT_PAYMENT.AUTO_ACCEPT,
    description: [
      "Ha elegido recibir una Office Depot eGiftCard de ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " que será enviado por correo electrónico a ",
      {
        string: "${payment.recipientEmail}",
        props: {
          className: 'payment-recipientEmail'
        }
      },
      "."
    ],
  },
  paymentComplete: {
    initial: {
      description: [
        "¡Éxito! Por favor, revise su correo electrónico ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " para obtener más información con respecto a su ",
        {
          string: "Office Depot eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " de ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ". Debería llegarle pronto e incluirá los detalles para su uso. ",
      ],
      secondaryText: "Por favor, considere esta tarjeta como si fuese dinero en efectivo y tenga el debido cuidado para evitar la pérdida o robo.",
    },
    revisit: {
      description: [
        "El ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt',
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        ", un correo electrónico fue enviado a ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " con los detalles respecto a su ",
        {
          string: "Office Depot eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " de ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        "."
        ],
      secondaryText: "Por favor, considere esta tarjeta como si fuese dinero en efectivo y tenga el debido cuidado para evitar la pérdida o robo.",
    },
  }
};

export default officeDepot;
